let notices = require( './notices' ),
	cta_cards = require( './cta-cards' );

let vibe_cake_masters_register_interest_forms = function( $ ) {

	let $register_forms;

	let _init = function() {
		$register_forms = $( 'form.register-interest-form.masters-form' );

		if ( $register_forms.length > 0 ) {
			_setup_forms();
		}
	};

	let _setup_forms = function() {
		$register_forms.not( '.initialised' ).each( ( index, item ) => {
			let $form = $( item );

			$form.on( 'submit', ( e ) => {
				e.preventDefault();
				_form_submit( $form );
			} );

			$form.addClass( 'initialised' );
		} );
	};

	let _form_submit = function( $form ) {
		let name   = $form.find( 'input[name="name"]' ).val(),
			email  = $form.find( 'input[name="email"]' ).val(),
			course = $form.data( 'course' );

		if ( ! course ) {
			window.alert( 'Error retrieving course please refresh the page and try again.' )
		} else {
			_register_interest( $form, course, name, email );
		}
	};

	let _register_interest = function( $form, course, name, email ) {
		$form.loading();

		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_register_interest_register_nonce,
			action: 'vibe_cake_masters_register_interest_register',
			course: course,
			name: name,
			email: email,
			type: 'not-account',
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				$form.closest( '.masters-modal' ).addClass( 'has-submitted' );
				cta_cards.update_card( course );
			} else if ( response.error ) {
				notices.add_notice( $form.find( '.form-notices' ), 'error', response.error );
			} else {
				window.alert( 'An unexpected error occurred please refresh the page and try again.' );
			}

			$form.loaded();
		} )
	};

	let register_interest = function ( type, course, email, name, $element_to_refresh ) {
		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_register_interest_register_nonce,
			action: 'vibe_cake_masters_register_interest_register',
			course: course,
			name: name,
			email: email,
			type: type,
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-registered-interest_success', { response : response } );
				}
			} else if ( response.error ) {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-registered-interest_error', { response : response } );
				}
			} else {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-registered-interest_unknown_error', { response : response } );
				}

				window.alert( 'An unexpected error occurred please refresh the page and try again.' );
			}
		} );
	};

	let unregister_interest = function(  type, course, email, $element_to_refresh  ) {
		let data = {
			nonce: VibeCakeMastersScriptData.vibe_cake_masters_register_interest_unregister_nonce,
			action: 'vibe_cake_masters_register_interest_unregister',
			course: course,
			email: email,
			type: type,
		};

		$.post( VibeCakeMastersScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-unregistered-interest_success', { response : response } );
				}
			} else if ( response.error ) {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-unregistered-interest_error', { response : response } );
				}
			} else {
				if ( $element_to_refresh ) {
					$element_to_refresh.trigger( 'masters-unregistered-interest_unknown_error', { response : response } );
				}

				window.alert( 'An unexpected error occurred please refresh the page and try again.' );
			}
		} )
	};

	$( document ).ready( _init );

	return {
		register_interest: register_interest,
		unregister_interest: unregister_interest,
	}

} ( jQuery );

module.exports = vibe_cake_masters_register_interest_forms;